
































































































































































































import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import CrudStepsNavBar from '@/reusable/Mantenedor/CrudStepsNavBar.vue';
import { PasosCrud } from '@/reusable/Mantenedor/mantenedorUtils';
import ContenidoModal from '@/reusable/Modal/ContenidoModal.vue';
import { fetchReportesSerie } from './fetchReporteSerie';
import TextField from '@/reusable/Form/TextField.vue';
import { Funcionalidades } from '@/config/funcionalidades';
import config from '@/config/index';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    CrudStepsNavBar,
    ContenidoModal,
    TextField,
    FormFieldsContainer,
  },
})
export default class VerCrearModal extends Vue {
  @Prop({ default: true }) show: boolean;
  readonly funcionalidad: Funcionalidades = Funcionalidades.EditarVehiculos;

  respuesta: any;
  dictionaryFormErrors: any = {};
  optionslist: any = [
    { text: 'Equipo', value: false },
    { text: 'Periferico', value: true },
  ];

  optionslist_2: any = [
    { text: 'ACTIVO', value: null },
    { text: 'INACTIVO', value: 1 },
  ];
  porductoList: any = [];
  plataformaList: any = [];
  tipoEquipoList: any = [];
  activaArriendo: boolean = false;
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  pasoActivoIndex = 1;
  readonly pasos: PasosCrud = {
    requerimiento: {
      accion: 'Crear Producto',
      visible: true,
      step: 1,
      title: 'Crear Producto',
      icon: 'ballot',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
    },
  };

  async getEquipos() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      { '': '' },
      'conecta_matriz_producto_comercial/get_grilla_filters'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.porductoList = data.data.PRODUCTO;
          self.plataformaList = data.data.PLATAFORMA;
          self.tipoEquipoList = data.data.TIPO_EQUIPO;
          self.formFields.codigoProducto.value = String(
            Number(data.data.CODIGO_EQUIPO[0].max) + 1
          );
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió Un Error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }
  async editar() {
    this.respuesta = await this.$validator.validateAll();
    let self = this;
    this.loadingService.showLoading();

    return fetchReportesSerie(
      {
        usuarioid_alta: JSON.parse(localStorage.getItem('user')).id,
        usuariorut_alta: JSON.parse(localStorage.getItem('user'))
          .rutClienteDefecto,
        tipoprodid: this.formFields.codigoProducto.value,
        tipoproddesc_corta: this.formFields.descripcionCorta.value
          .toString()
          .toUpperCase(),
        tipoproddesc_larga: this.formFields.descripcionLarga.value
          .toString()
          .toUpperCase(),
        tipoprodcod_producto: this.formFields.codigoProductoP.value,
        tipoprodcod_inet: this.formFields.codigoInet.value,
        tipoprodcuenta_ingreso: this.formFields.cuentaIngreso.value,
        tipoprodcuenta_costo: this.formFields.cuentaCosto.value,
        tipoprodplataforma: this.formFields.plataforma.value,
        tipoprodclase: this.formFields.producto.value, //
        tipoeqid: this.formFields.tipoequipo.value, //
        tipoprodnombre_crm: this.formFields.nombrecrm.value
          .toString()
          .toUpperCase(),
        activaArriendo: this.activaArriendo,
        visible_cotizador: this.formFields.visible_cotizador.value
      },
      'conecta_matriz_producto_comercial/crear_producto'
    )
      .then((data: any) => {
        if (this.respuesta == false) {
          self.$snotify.error('Por Favor Ingrese Los Campos Requeridos', {
            timeout: 3000,
          });
          return;
        }
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.handleCerrar();
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió Un Error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  formFields: FormFieldDefMap = {
    nombrecrm: {
      label: 'Nombre en CRM*',
      id: '',
      value: '',
    },
    codigoProducto: {
      label: 'ID de Producto',
      id: '',
      value: '',
    },
    codigoProductoP: {
      label: 'Código de Producto*',
      id: '',
      value: '',
    },
    codigoInet: {
      label: 'Código de INET*',
      id: '',
      value: '',
    },
    descripcionCorta: {
      label: 'Descripción Corta*',
      id: '',
      value: '',
    },
    descripcionLarga: {
      label: 'Descripción Larga*',
      id: '',
      value: '',
    },
    cuentaIngreso: {
      label: 'Cuenta Ingreso',
      id: '',
      value: '',
    },
    cuentaCosto: {
      label: 'Cuenta Costo',
      id: '',
      value: '',
    },
    producto: {
      label: 'Clase Producto',
      id: '',
      value: '',
    },
    plataforma: {
      label: 'Plataforma',
      id: '',
      value: '',
    },
    tipoequipo: {
      label: 'Tipo Equipo',
      id: '',
      value: '',
    },
    estado: {
      label: 'Estado',
      id: 'ACTIVO',
      value: 'ACTIVO',
    },
    visible_cotizador: {
      label: 'Visible Cotizador',
      id: 'true',
      value: 'true',
    }
  };

  mounted() {
    this.getEquipos();

    this.dictionaryFormErrors = {
      custom: {
        rut: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
          regex: () => config.errorMensajes.regex,
        },
        name: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
          alpha_spaces: () =>
            '* El campo Nombre solo debe contener letras y/o espacios.',
        },
        ubicacion: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
        },
        apellidoPaterno: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
          alpha_spaces: () =>
            '* El campo Apellido Paterno solo debe contener letras y/o espacios.',
        },
        apellidoMaterno: {
          max: () => config.errorMensajes.maxLength,
          alpha_spaces: () =>
            '* El campo Apellido Materno solo debe contener letras y/o espacios.',
        },
        email: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
        },
        contrasena: {
          required: () => config.errorMensajes.textoRequerido,
          confirmed: () => config.errorMensajes.passNoIguales,
          min: () => 'El campo debe tener al menos 8 caracteres.',
        },
        direccion: {
          max: () => config.errorMensajes.maxLength,
        },
        telefonoFijo: {
          max: () => config.errorMensajes.maxLength,
          numeric: () => 'El campo debe ser unicamente numérico',
        },
        telefonoFijo2: {
          max: () => config.errorMensajes.maxLength,
          numeric: () => 'El campo debe ser unicamente numérico',
        },
        telefonoFijo3: {
          max: () => config.errorMensajes.maxLength,
          numeric: () => 'El campo debe ser unicamente numérico',
        },
        telefonoFijo4: {
          max: () => config.errorMensajes.maxLength,
          numeric: () => 'El campo debe ser unicamente numérico',
        },
        celular: {
          max: () => config.errorMensajes.maxLength,
          regex: () => config.errorMensajes.regex,
        },
        estado: {
          required: () => config.errorMensajes.textoRequerido,
        },
        fechaNacimiento: {
          mayorDeEdad: () => config.errorMensajes.fechaMayoriaEdad,
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
        },
      },
    };
    this.$validator.localize('es', this.dictionaryFormErrors);
  }
  @Watch('ReporteSeleccionado')
  handleRutasSeleccionadas() {
    return;
  }

  handleCerrar() {
    this.$emit('cerrarCrear');
  }
}
